<script src="../../../../../assets/js/globalne_funkcije/Racuni/PridobitevRacunov.js"></script>
<template>
  <div class="odmik-vsebine-poraba-telefonija" style="clear: both">
    <div v-if="this.imePaketa !== ''" style="padding-bottom: 40px">
      <p>
        Paket izbrane številke:
        <b v-if="this.imePaketa !== null && this.imePaketa !== ''">
          {{ this.imePaketa }} {{ this.infoSporocilPaketa }}
        </b>
        <b v-else>
          /
        </b>
      </p>
    </div>
    <div v-loading="nalaganjeStatistikeKlicev" v-if="izbranaJeUMTSStevilka || izbranaJeFiskaStevilka && !imaPodatkovniPaket">
      <div class="velikost-prikaza-progressbar">
        <div>
          <div style="padding-bottom: 20px">
            <ul>
              <li>
                <img src="/static/img/Poraba/PorabaTelefonija/Icon-material-smartphone.png" class="icona-naslov">
                <span class="open-sans-20pt" style="margin-top: 30px">
                   KLICI
                </span>
              </li>
            </ul>
          </div>
          <div>
            <div class="prikaz-podatkov-poraba" v-if="seznamKlicevIzpis.length > 0">
              <div v-for="object in seznamKlicevIzpis">
                <div class="box-notranja-postavitev-manjsi-stNakupov">
                  <p>
                    <b class="primarna-barva velikost-pisave-povzetek-info" style="text-align: center">
                      {{ object.used_unit }}
                    </b>
                    <span v-if="typeof object.limit !== 'undefined'" class="velikost-pisave-povzetek-info">
                      /  {{ object.limit }}
                    </span>
                    <span v-if="typeof object.unit !== 'undefined'" class="velikost-pisave-povzetek-info">
                      {{ object.unit }}
                    </span>
                  </p>
                  <p class="open-sans-14pt" style="text-align: center">
                    {{ object.description }}
                  </p>
                </div>
              </div>
            </div>
            <div v-else>
              <div class="obvestilo-poraba">
                Na izbrani številki ni bilo opravljenih klicev.
              </div>
            </div>
          </div>
        </div>
      </div>
      <div style="padding-bottom: 30px">
        <div style="padding-top: 30px">
          <el-button class="okvir-podroben-pregled tekst-podroben-pregled"
                     @click="OdpriPregledKlicev" v-if="povzetekKlicev === false">
            PODROBNI PREGLED
          </el-button>
        </div>
        <div style="padding-top: 20px" v-if="povzetekKlicev === false && izbranaJeUMTSStevilka">
          <span class="opozorilo-klici">
            <el-icon class="el-icon-info" style="padding-top:5px">
            </el-icon>
            <span class="opozorilo-mobile">
              Izpis klicev in porabe sta informativne narave.
              V podrobnem pregledu boste našli povzetek v posamezno omrežje in povzetek vseh klicev.
            </span>
          </span>
        </div>
        <div style="padding-top: 20px" v-if="povzetekKlicev === false && izbranaJeFiskaStevilka">
          <span class="opozorilo-klici">
            <el-icon class="el-icon-info" style="padding-top:5px">
            </el-icon>
            <span class="opozorilo-mobile link-bottom">
              Izpis klicev in porabe sta informativne narave. V podrobnem pregledu boste našli povzetek vseh klicev
              in v posamezno omrežje.
            </span>
          </span>
        </div>
        <div v-if="povzetekKlicev === true">
          <div>
            <p class="open-sans-14pt">
              <b>
                Povzetek vseh klicev
              </b>
            </p>
            <div v-if="prikazTabele === '1'">
              <table style="width: 100%">
                <tr>
                  <th class="sirina-stolpca-povzetek-vseh-klicev">
                    Število klicev
                  </th>
                  <th class="sirina-stolpca-povzetek-vseh-klicev">
                    Trajanje (v sek.)
                  </th>
                  <th>
                    Znesek v € (z DDV)
                  </th>
                </tr>
                <tr>
                  <td>
                    {{ SkupnoSteviloVsehKlicev }}
                  </td>
                  <td>
                    {{ skupnaKolicinaSekund }}
                  </td>
                  <td>
                    {{ skupnaKolicinaZnesek }}
                  </td>
                </tr>
              </table>
            </div>
            <div v-else>
              <table>
                <p>
                  <span>
                    <b>
                     Število klicev:
                    </b>
                  </span>
                  {{ SkupnoSteviloVsehKlicev }}
                </p>
                <p>
                  <span>
                    <b>
                      Trajanje (v sek.):
                    </b>
                  </span>
                  {{ skupnaKolicinaSekund }}
                </p>
                <p>
                  <span>
                    <b>
                     Znesek v € (z DDV):
                    </b>
                  </span>
                  {{ skupnaKolicinaZnesekSI }}
                </p>
              </table>
            </div>
          </div>
          <br/>
          <div style="padding-top: 30px">
            <p class="open-sans-14pt">
              <b>
                Povzetek klicev v posamezno omrežje
              </b>
            </p>
            <div v-if="prikazTabele === '1'">
              <el-table :data="seznamRazdeljenihKlicev">
                <el-table-column label="Klicano omrežje"
                                 prop="description">
                </el-table-column>
                <el-table-column label="Število klicev"
                                 prop="transCount">
                </el-table-column>
                <el-table-column label="Trajanje (v sek.)"
                                 prop="actualQuantity">
                </el-table-column>
                <el-table-column prop="formatZnesek"
                                 label="Znesek v € (z DDV)">
                </el-table-column>
              </el-table>
            </div>
            <div v-if="prikazTabele === '0'">
              <el-table :data="seznamRazdeljenihKlicev">
                <el-table-column>
                  <template slot-scope="props">
                    <p>
                      <span>
                        <b>
                          Klicano omrežje:
                        </b>
                      </span>
                      {{ props.row.description }}
                    </p>
                    <p>
                      <span>
                        <b>
                          Število klicev:
                        </b>
                      </span>
                      {{ props.row.transCount }}
                    </p>
                    <p>
                      <span>
                        <b>
                          Trajanje (v sek.):
                        </b>
                      </span>
                      {{ props.row.actualQuantity }}
                    </p>
                    <p>
                      <span>
                        <b>
                          Znesek v € (z DDV):
                        </b>
                      </span>
                      {{ props.row.formatZnesek }}
                    </p>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </div>
          <div style="padding-top: 30px">
            <el-button class="okvir-podroben-pregled tekst-podroben-pregled" @click="ZapriPregledKlicev">
              ZAPRI PREGLED
            </el-button>
          </div>
          <div style="padding-top: 20px" v-if="povzetekKlicev === true && izbranaJeUMTSStevilka">
            <span class="opozorilo-klici">
              <el-icon class="el-icon-info" style="padding-top:5px">
              </el-icon>
              <span class="opozorilo-mobile">
                Izpis klicev in porabe sta informativne narave.
                V podrobnem pregledu boste našli povzetek v posamezno omrežje in povzetek vseh klicev.
              </span>
            </span>
          </div>
          <div style="padding-top: 20px" v-if="povzetekKlicev === true && izbranaJeFiskaStevilka">
          <span class="opozorilo-klici">
            <el-icon class="el-icon-info" style="padding-top:5px">
            </el-icon>
            <span class="opozorilo-mobile link-bottom">
              Izpis klicev in porabe sta informativne narave.
              V podrobnem pregledu boste našli povzetek v posamezno omrežje in povzetek vseh klicev.
            </span>
          </span>
          </div>
        </div>
      </div>
      <hr class="hr-stil"/>
    </div>
    <div class="odmik-kartice" v-if="seznamRazdeljenihSmsov.length >= 0 && izbranaJeUMTSStevilka && !imaPodatkovniPaket">
      <div class="velikost-prikaza-progressbar" v-loading="nalaganjeStatistikeKlicev">
        <div style="float: left; margin-left: -25px">
          <i class="fa fa-envelope" style="font-size:24px; margin-right: 10px"></i>
        </div>
        <div style="padding-bottom: 20px">
          <ul>
            <li>
              <img src="/static/img/Poraba/PorabaTelefonija/Icon-material-textsms.png" class="icona-naslov">
              <span class="open-sans-20pt" style="margin-top: 30px">
                SMS/MMS SPOROČILA
              </span>
            </li>
          </ul>
        </div>
        <div>
          <div class="prikaz-podatkov-poraba" v-if="seznamSporocilIzpis.length > 0">
            <div v-for="object in seznamSporocilIzpis">
              <div class="box-notranja-postavitev-manjsi-stNakupov">
                <p style="text-align: center">
                  <b class="primarna-barva velikost-pisave-povzetek-info">
                    {{ object.used_unit }}
                  </b>
                  <span v-if="typeof object.limit !== 'undefined'" class="velikost-pisave-povzetek-info">
                    /  {{ object.limit }}
                  </span>
                  <span v-if="typeof object.unit !== 'undefined'" class="velikost-pisave-povzetek-info">
                    {{ object.unit }}
                  </span>
                </p>
                <p class="open-sans-14pt" style="text-align: center">
                  {{ object.description }}
                </p>
              </div>
            </div>
          </div>
          <div v-else>
            <div class="obvestilo-poraba">
              Na izbrani številki ni bilo poslanih SMS-ov.
            </div>
          </div>
        </div>
      </div>
      <div class="collapse-sms-mms" style="padding-bottom: 47px">
        <div style="padding-top: 30px">
          <el-button class="okvir-podroben-pregled tekst-podroben-pregled"
                     @click="OdpriPregledSmsMmsSporocila" v-if="smsMmsSporocila !== true">
            PODROBNI PREGLED
          </el-button>
          <div style="padding-top: 20px" v-if="smsMmsSporocila === false">
          <span class="opozorilo-klici">
            <el-icon class="el-icon-info" style="padding-top:5px">
            </el-icon>
            <span class="opozorilo-mobile">
              Izpis poslanih sporočil in porabe sta informativne narave.
              V podrobnem pregledu boste našli seznam poslanih sporočil.
            </span>
          </span>
          </div>
        </div>
        <div v-if="smsMmsSporocila === true">
          <div>
            <p class="open-sans-14pt">
              <b>
                Povzetek sporočil (SMS/MMS)
              </b>
            </p>
            <br/>
            <span>
              <p>
                Skupaj sporočil:
                <b>
                  {{ dolzinaSeznamaSms }}
                </b>
              </p>
              <p>
                Skupaj znesek v € (z DDV):
                <b>
                  {{ skupniZnesekSmsov }}
                </b>
              </p>
            </span>
            <br/>
            <div v-if="prikazTabele === '1'">
              <el-table :data="seznamRazdeljenihSmsov" width="100%">
                <el-table-column prop="description"
                                 label="Opis storitve"
                                 width="280">
                </el-table-column>
                <el-table-column prop="transCount"
                                 label="Število sej"
                                 width="280">
                </el-table-column>
                <el-table-column prop="formatZnesekMessage"
                                 label="Znesek v € (z DDV)">
                </el-table-column>
              </el-table>
            </div>
            <div v-else>
              <el-table :data="seznamRazdeljenihSmsov">
                <el-table-column>
                  <template slot-scope="props">
                    <p>
                      <span>
                        <b>
                          Opis storitve:
                        </b>
                      </span>
                      {{ props.row.description }}
                    </p>
                    <p>
                      <span>
                        <b>
                          Število sej:
                        </b>
                      </span>
                      {{ props.row.transCount }}
                    </p>
                    <p>
                      <span>
                        <b>
                          Znesek v € (z DDV):
                        </b>
                      </span>
                      {{ props.row.formatZnesekMessage }}
                    </p>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </div>
          <div style="padding-top: 40px">
            <p class="open-sans-14pt">
              <b>
                Seznam sporočil (SMS/MMS)
              </b>
            </p>
            <div v-if="prikazTabele === '1'">
              <el-table :data="podseznamPodatkovSmsov" style="width: 100%">
                <el-table-column prop="formatDatumaSms"
                                 label="Datum"
                                 width="">
                </el-table-column>
                <el-table-column prop="callee"
                                 label="Destinacija"
                                 width="">
                </el-table-column>
                <el-table-column prop="description"
                                 label="Opis storitve"
                                 width="400px">
                </el-table-column>
                <el-table-column prop="znesekSMSinMMSFormat"
                                 label="Znesek v € (z DDV)">
                </el-table-column>
              </el-table>
            </div>
            <div v-else>
              <el-table :data="podseznamPodatkovSmsov">
                <el-table-column>
                  <template slot-scope="props">
                    <p>
                      {{ props.row.formatDatumaSms }}
                    </p>
                    <p>
                      <span>
                        <b>
                          Destinacija:
                        </b>
                      </span>
                      {{ props.row.description }}
                    </p>
                    <p>
                      <span>
                        <b>
                          Znesek v € (z DDV):
                        </b>
                      </span>
                      {{ props.row.znesekSMSinMMSFormat }}
                    </p>
                  </template>
                </el-table-column>
              </el-table>
            </div>
            <div class="text-center">
              <br/>
              <el-pagination
                :hide-on-single-page="true"
                @current-change="PrikaziStranSms"
                :current-page="trenutnoIzbranaStranSms"
                :page-size="4"
                layout="prev, pager, next"
                :total="dolzinaSeznamaSms"
                small>
              </el-pagination>
            </div>
          </div>
          <div style="padding-top: 20px">
            <el-button class="okvir-podroben-pregled tekst-podroben-pregled"
                       @click="ZapriPregledSmsMmsSporocila">
              ZAPRI PREGLED
            </el-button>
          </div>
          <div style="padding-top: 20px" v-if="smsMmsSporocila === true">
            <span class="opozorilo-klici">
              <el-icon class="el-icon-info" style="padding-top:5px">
              </el-icon>
              <span class="opozorilo-mobile link-bottom">
                Izpis klicev in porabe je informativne narave, zgodovino vseh številk beležimo za zadnje 3 mesece, cene
                so v evrih in natančne do četrte decimalke. Uporabnikom omogočamo uporabo mobilnih storitev v državah
                Evropske unije po pogojih in cenah kot doma ter v skladu s pogoji posameznega naročniškega paketa. Več
                informacij o gostovanju v EU in zaračunavanju pribitkov boste našli
                <a :href="povezavaEuGostovanjePovezava" class="primarna-barva" target="_blank">tukaj</a>.
              </span>
            </span>
          </div>
        </div>
      </div>
      <hr class="hr-stil"/>
    </div>
    <div class="odmik-kartice" v-if="this.seznamPrenosaPodatkov.length >= 0 && imaPodatkovniPaket || izbranaJeUMTSStevilka">
      <div class="velikost-prikaza-progressbar" v-loading="nalaganjeStatistikeKlicev">
        <div style="padding-bottom: 20px">
          <ul>
            <li>
              <img src="/static/img/UporabniskiKoticek/UporabneStrani/Icon-awesome-wifi.png"  class="icona-naslov">
              <span class="open-sans-20pt" style="margin-top: 30px">
                MOBILNI PODATKI
              </span>
            </li>
          </ul>
        </div>
        <div class="prikaz-podatkov-poraba" v-if="seznamMobilnihPodatkovIzpis.length > 0">
          <div v-for="object in seznamMobilnihPodatkovIzpis">
            <div class="box-notranja-postavitev-manjsi-stNakupov">
              <p style="text-align: center">
                <b class="primarna-barva velikost-pisave-povzetek-info">
                  {{ Number(object.used_unit).toFixed(2) }}
                  <span v-if="typeof object.unit !== 'undefined'">
                    {{ object.unit }}
                  </span>
                </b>
                <span v-if="typeof object.limit !== 'undefined' && object.rum !== 'VOL'" class="velikost-pisave-povzetek-info">
                  / {{ Number(object.limit).toFixed(2) }} GB
                </span>
                <span class="navadno-besedilo" v-if="object.limit === 0 && object.rum === 'VOL' " style="font-size: 25px">
                / ∞
                </span>
                <span v-if="typeof object.limit === 'undefined'" class="velikost-pisave-povzetek-info">
                  {{ object.unit }}
                </span>
              </p>
              <p class="open-sans-14pt" style="text-align: center">
                {{ object.description }}
              </p>
            </div>
          </div>
        </div>
        <div v-else>
          <div class="obvestilo-poraba">
            Na izbrani številki ni bilo prenosa mobilnih podatkov.
          </div>
        </div>
      </div>
      <div style="padding-bottom: 25px">
        <div style="padding-top: 30px">
          <el-button class="okvir-podroben-pregled tekst-podroben-pregled"
                     @click="OdpriPregledMobilniPodatki" v-if="mobilniPodatki === false">
            PODROBNI PREGLED
          </el-button>
        </div>
        <div style="padding-top: 20px" v-if="mobilniPodatki === false">
          <span class="opozorilo-klici">
            <el-icon class="el-icon-info" style="padding-top:5px">
            </el-icon>
            <span class="opozorilo-mobile">
              Izpis količine prenosa in porabe sta informativne narave.
              V podrobnem pregledu boste našli povzetek porabe podatkovnih storitev.
            </span>
          </span>
        </div>
        <div v-if="mobilniPodatki === true">
          <div>
            <p class="open-sans-14pt">
              <b>
                Povzetek porabe podatkovnih storitev
              </b>
            </p>
            <div v-if="prikazTabele === '1'">
              <el-table :data="seznamPrenosaPodatkov">
                <el-table-column prop="description"
                                 label="Opis storitve"
                                 width="400px">
                </el-table-column>
                <el-table-column prop="transCount"
                                 label="Število sej">
                </el-table-column>
                <el-table-column prop="kolicinaPrenosa"
                                 label="Količina prenosa">
                  <template slot-scope="scope">
                    <p v-if="typeof scope.row.limit !== 'undefined'">
                      {{getDataRoaming(scope.row)}}
                    </p>
                    <p v-else>
                      {{ scope.row.kolicinaPrenosa }}
                    </p>
                  </template>
                </el-table-column>
                <el-table-column prop="formatZnesekData" label="Znesek v € (z DDV)">
                </el-table-column>
              </el-table>
            </div>
            <div v-else>
              <el-table :data="seznamPrenosaPodatkov">
                <el-table-column>
                  <template slot-scope="props">
                    <p>
                      <span>
                        <b>
                          Opis storitve:
                        </b>
                      </span>
                      {{ props.row.description }}
                    </p>
                    <p>
                      <span>
                        <b>
                          Število sej:
                        </b>
                      </span>
                      {{ props.row.transCount }}
                    </p>
                    <p>
                      <span>
                        <b>
                          Količina prenosa:
                        </b>
                      </span>
                    <p v-if="typeof props.row.limit !== 'undefined'">
                      {{ props.row.used_unit }} / {{ props.row.limit }} {{ props.row.unit }}
                    </p>
                    <p v-else>
                      {{ props.row.kolicinaPrenosa }}
                    </p>
                    <p>
                      <span>
                        <b>
                          Znesek v € (z DDV):
                        </b>
                      </span>
                      {{ props.row.formatZnesekData }}
                    </p>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </div>
          <div style="padding-top: 20px">
            <el-button class="okvir-podroben-pregled tekst-podroben-pregled"
                       @click="ZapriPregledMobilniPodatki">
              ZAPRI PREGLED
            </el-button>
          </div>
        </div>
        <div style="padding-top: 20px" v-if="mobilniPodatki === true">
          <span class="opozorilo-klici">
            <el-icon class="el-icon-info" style="padding-top:5px">
            </el-icon>
            <span class="opozorilo-mobile link-bottom">
              Izpis porabe je informativne narave. Količini porabljenega podatkovnega prenosa v EU in domačem omrežju
              se seštevata do zakupljene količine, ki jo paket vsebuje. Uporabnikom omogočamo uporabo mobilnih storitev
              v državah Evropske unije po pogojih in cenah kot doma ter v skladu s pogoji posameznega naročniškega
              paketa. Več informacij o gostovanju v EU in zaračunavanju pribitkov boste našli
              <a :href="povezavaEuGostovanjePovezava" class="primarna-barva" target="_blank">tukaj</a>.
            </span>
          </span>
        </div>
      </div>
      <hr class="hr-stil"/>
    </div>
    <div style="padding-top: 40px; padding-bottom: 5px">
      <el-button class="gumb-potrdi" @click="IzvozExcel">
        <img src="../../../../../../static/img/Icon/PorabaTelefonija/Icon-file-excel-regular.png">
        IZVOZ POVZETKA PORABE
      </el-button>
    </div>
    <span class="opozorilo" v-if="!dodatnoZakupljeneEnotePrikaz">
      <el-icon class="el-icon-info" style="padding-top:5px">
      </el-icon>
      <span class="opozorilo-mobile">
        Izpis klicev in porabe za izbrano številko sta informativne narave, zgodovino vseh številk beležimo za
        zadnje 3 mesece, cene so v evrih in natančne do četrte decimalke.
      </span>
    </span>
    <span class="opozorilo" v-if="dodatnoZakupljeneEnotePrikaz">
      <el-icon class="el-icon-info" style="padding-top:5px">
      </el-icon>
      <span class="opozorilo-mobile">
        Enota je 1 minuta pogovora ali MMS/SMS sporočilo v vsa slovenska telekomunikacijska omrežja ali 1 MB
        prenesenega mobilnega podatkovnega prometa in sicer iz omrežja T-2 ali iz omrežja, pri katerem ima T-2 sklenjeno
        nacionalno gostovanje. Pogoji uporabe mobilnih paketov in uporabe enot so na voljo
        <a :href="povezavaSplosniPogoji" class="primarna-barva" target="_blank">tukaj</a>.
      </span>
    </span>
  </div>
</template>
<script>
import Vue from 'vue'
import {ObdelavaDatuma} from 'src/assets/js/globalne_funkcije/SplosneGlobalneFunkcije/IzbiraMeseca.js'
import {FormatDatuma} from 'src/assets/js/globalne_funkcije/SplosneGlobalneFunkcije/FormatDatuma'
import {PretvorbaEnot} from 'src/assets/js/globalne_funkcije/SplosneGlobalneFunkcije/PretvorbaEnotB.js'
import {
  Checkbox, Button, Select, Option, Card, Table, TableColumn, Progress, Collapse, CollapseItem,
  Tooltip
} from 'element-ui'
import {PovezaveMobilniPaketi} from '../../../../../assets/js/PovezaveMobilniPaketi/PovezaveMobilniPaketi'
import {StringConverter} from 'src/assets/js/globalne_funkcije/SplosneGlobalneFunkcije/StringConverter'
import ClientAgent from '../../../../../assets/js/clientAgent.js'
import {PrikazVsebine} from 'src/assets/js/globalne_funkcije/SplosneGlobalneFunkcije/SirinaOkna.js'
import JsonExcel from 'vue-json-excel'
import {povezave} from '../../../../../assets/js/Povezave/povezave'
import {StopnjaDDVEnum} from '../../../../../assets/js/Enum/StopnjaDDVEnum'

Vue.component('downloadExcel', JsonExcel)
export default {
  name: 'porabatelefonija',
  mixins: [PrikazVsebine, ObdelavaDatuma, PretvorbaEnot, FormatDatuma, StringConverter],
  components: {
    ObdelavaDatuma,
    PretvorbaEnot,
    [Checkbox.name]: Checkbox,
    [Button.name]: Button,
    [Select.name]: Select,
    [Option.name]: Option,
    [Card.name]: Card,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Progress.name]: Progress,
    [Collapse.name]: Collapse,
    [CollapseItem.name]: CollapseItem,
    [Tooltip.name]: Tooltip
  },
  data () {
    return {
      clientAgent: null,
      seznamKlicev: [],
      izpisZakupljenihEnot: true,
      seznamSmsov: [],
      podseznamPodatkovSmsov: [],
      seznamKlicevTujina: [],
      seznamRazdeljenihSmsov: [],
      seznamRazdeljenihKlicev: [],
      seznamKlicevSloOmrezje: [],
      seznamPrenosaPodatkov: [],
      seznamKlicevVT2Omrezje: [],
      seznamKlicevVTelemachOmrezje: [],
      skupnoSteviloKlicevVSloveniji: 0,
      skupnoSteviloKlicevVT2: 0,
      skupnoSteviloKlicevTujina: 0,
      skupnaKolicinaZnesek: 0,
      skupnaKolicinaZnesekSI: '0',
      steviloMmsov: 0,
      skupniZnesekSmsov: 0,
      nalaganjeStatistikeKlicev: false,
      mobilniPodatki: false,
      smsMmsSporocila: false,
      povzetekKlicev: false,
      SkupnoSteviloVsehKlicev: 0,
      dolzinaSeznamaSms: null,
      trenutnoIzbranaStranSms: 1,
      steviloSmsov: 0,
      mobilniPaketMaxi: '',
      mobilniPaketMidi: '',
      mobilniPaketMini: '',
      mobilniPaketTop: '',
      vecInfoOpaketu: '',
      infoSporocilPaketa: null,
      kliciVt2Omrezje: '',
      nazivStoritve: '',
      imePaketa: null,
      skupnaKolicinaSekund: 0,
      povezavaSplosniPogoji: null,
      prenosPodatkovTelekom: 0,
      prenosPodatkovT2: 0,
      infoIzbraneStevilke: null,
      imaPodatkovniPaket: false,
      povezavaEuGostovanjePovezava: '',
      dodatnoZakupljeneEnotePrikaz: false,
      dodatnoZakupljeneEnote: 0,
      dodatnoZakupljeneEnoteLimit: 0,
      izbranaJeFiskaStevilka: false,
      izbranaJeUMTSStevilka: false,
      seznamMobilnihPodatkovIzpis: [],
      seznamKlicevIzpis: [],
      seznamSporocilIzpis: []
    }
  },
  props: {
    izbranSap: '',
    telefonskaStevilka: '',
    telefonskeStevilkeStrankeAsoc: {
      type: Object,
      default () {
        return {}
      }
    },
    izbranMesec: '',
    izbranid: '',
    idStroskovniNosilec: '',
    idPrikljucek: '',
    trznipaket: '',
    stevecPoizvedb: 0,
    seznamTelefonskihStevilkUmts: {
      type: Array,
      default () {
        return []
      }
    }
  },
  created () {
    this.clientAgent = new ClientAgent()
  },
  mounted () {
    this.PretvoriKolicinoVPrijaznoOblikoMb()
    this.DolociIzbranMesec()
    this.mobilniPaketMaxi = PovezaveMobilniPaketi.BASE_URL_MOBILNI_PAKET_MAXI
    this.mobilniPaketMidi = PovezaveMobilniPaketi.BASE_URL_MOBILNI_PAKET_MIDI
    this.mobilniPaketMini = PovezaveMobilniPaketi.BASE_URL_MOBILNI_PAKET_MINI
    this.mobilniPaketTop = PovezaveMobilniPaketi.BASE_URL_MOBILNI_PAKET_TOP
    this.povezavaSplosniPogoji = povezave.BASE_URL_SPLOSNI_POGOJI_PODJETJA
    this.povezavaEuGostovanjePovezava = povezave.BASE_URL_GOSTOVANJE_V_EVROPSKI_UNIJI
    this.$nextTick(function () {
      window.addEventListener('resize', this.SirinaOknaPresegaVrednost)
      window.dispatchEvent(new Event('resize'))
    })
    this.povezave = povezave.BASE_URL_SPLOSNI_POGOJI_PODJETJA
  },
  methods: {
    getDataRoaming (item) {
      if (this.imePaketa === 'Mobilni TOP') {
        return ((Number(item.used_unit) / 100) * (1 + (StopnjaDDVEnum.DDV_PROCENTUALNO / 100))).toFixed(2) +
          ' / ' + (Number(item.limit) / 100) * (1 + (StopnjaDDVEnum.DDV_PROCENTUALNO / 100)).toFixed(2) + ' ' +
          item.unit
      } else {
        return item.used_unit + ' / ' + item.limit + ' ' + item.unit
      }
    },
    OdpriPregledMobilniPodatki () {
      this.mobilniPodatki = true
    },
    ZapriPregledMobilniPodatki () {
      this.mobilniPodatki = false
    },
    OdpriPregledSmsMmsSporocila () {
      this.smsMmsSporocila = true
    },
    ZapriPregledSmsMmsSporocila () {
      this.smsMmsSporocila = false
    },
    OdpriPregledKlicev () {
      this.povzetekKlicev = true
    },
    ZapriPregledKlicev () {
      this.povzetekKlicev = false
    },
    IzvozExcel () {
      if (this.izbranSap !== '') {
        if (this.telefonskaStevilka !== null && this.telefonskaStevilka !== '') {
          let izbranoObdobje = this.DolociIzbranMesec()
          let param = ['telefonskaStevilka=' + this.telefonskaStevilka]
          param.push('datumOd=' + izbranoObdobje.trajanjeOd)
          param.push('datumDo=' + izbranoObdobje.trajanjeDo)
          param.push('izpisZakuplenihEnot=' + this.izpisZakupljenihEnot)
          param.push('izvoz=true')
          this.clientAgent.postWsRequest(
            this,
            'mercury/poraba',
            param,
            null,
            'SetPorabaIzvoz',
            'ErrPorabaIzvoz')
        }
      }
    },
    SetPorabaIzvoz (podatki) {
      let data = podatki.exportData
      let izvoz = document.createElement('a')
      izvoz.href = 'data:applilcation/xls;base64,' + data
      izvoz.download = 'izvoz-povzetka-porabe-' + this.telefonskaStevilka + '.xls'
      izvoz.click()
    },
    ResetPodatkov () {
      this.seznamRazdeljenihKlicev = []
      this.SkupnoSteviloVsehKlicev = 0
      this.skupnaKolicinaSekund = 0
      this.skupnaKolicinaZnesek = 0
      this.skupnaKolicinaZnesekSI = '0'
      this.skupnoSteviloKlicevTujina = 0
      this.skupnoSteviloKlicevVSloveniji = 0
      this.skupnoSteviloKlicevVT2 = 0
      this.dolzinaSeznamaSms = 0
      this.skupniZnesekSmsov = 0
      this.seznamRazdeljenihSmsov = []
      this.podseznamPodatkovSmsov = []
      this.seznamPrenosaPodatkov = []
    },
    GetPorabaInfo () {
      if (this.izbranSap !== '') {
        this.nalaganjeStatistikeKlicev = true
        if (this.telefonskaStevilka !== '') {
          let izbranoObdobje = this.DolociIzbranMesec()
          let param = []
          param.push('telefonskaStevilka=' + this.telefonskaStevilka)
          param.push('datumOd=' + izbranoObdobje.trajanjeOd)
          param.push('datumDo=' + izbranoObdobje.trajanjeDo)
          param.push('izpisZakuplenihEnot=' + this.izpisZakupljenihEnot)
          param.push('cache=' + false)
          if (this.statusIzvoza === true) {
            param.push('izvoz=true')
            this.statusIzvoza = false
          }
          if (this.clientAgent === null) {
            this.clientAgent = new ClientAgent()
          }
          this.clientAgent.postWsRequest(
            this,
            'mercury/poraba',
            param,
            null,
            'SetPorabaInfo',
            'ErrPorabaInfo')
        }
      }
    },
    SetPorabaInfo (podatki) {
      this.SetTelStStranke(null, podatki)
    },
    ErrPorabaInfo (podatki) {
      let paramObvestilo = {}
      paramObvestilo.message = podatki.message
      this.ShowWarningMessage(paramObvestilo)
      this.nalaganjeStatistikeKlicev = false
    },
    PodatkiStevilke () {
      this.imaPodatkovniPaket = false
      this.imePaketa = null
      this.infoIzbraneStevilke = null
      this.izbranaJeFiskaStevilka = false
      this.izbranaJeUMTSStevilka = false
      for (let i = 0; i < this.seznamTelefonskihStevilkUmts.length; i++) {
        if (this.telefonskaStevilka === this.seznamTelefonskihStevilkUmts[i].msisdn) {
          this.infoIzbraneStevilke = this.seznamTelefonskihStevilkUmts[i]
          if (this.infoIzbraneStevilke.tip_stevilke === '1' || this.infoIzbraneStevilke.tip_stevilke === 1) {
            this.izbranaJeFiskaStevilka = true
          } else if (this.infoIzbraneStevilke.tip_stevilke === '5' || this.infoIzbraneStevilke.tip_stevilke === 5) {
            this.izbranaJeUMTSStevilka = true
          }
          if (this.seznamTelefonskihStevilkUmts[i].trzni_paket !== '') {
            this.imePaketa = this.seznamTelefonskihStevilkUmts[i].trzni_paket
          } else if (this.seznamTelefonskihStevilkUmts[i].podatkovni_paket !== '') {
            this.imePaketa = this.seznamTelefonskihStevilkUmts[i].podatkovni_paket
            this.imaPodatkovniPaket = true
            this.izbranaJeUMTSStevilka = false
          } else {
            this.imePaketa = 'Ni podatka'
          }
        }
      }
    },
    SetTelStStranke (noviPodatki, prenosniPodatki) {
      this.PodatkiStevilke()
      if (typeof prenosniPodatki !== 'undefined' &&
        typeof prenosniPodatki.units !== 'undefined' && prenosniPodatki.units !== null &&
        prenosniPodatki.units.information !== null) {
        this.nazivStoritve = ''
        this.vecInfoOpaketu = ''
        this.infoSporocilPaketa = null
        this.dodatnoZakupljeneEnote = 0
        this.dodatnoZakupljeneEnoteLimit = 0
        this.dolzinaSeznamaSms = 0
        this.seznamSmsov = []
        this.seznamRazdeljenihSmsov = []
        this.seznamPrenosaPodatkov = []
        this.skupniZnesekSmsov = 0
        this.prenosPodatkovT2 = 0
        this.prenosPodatkovTelekom = 0
        this.steviloSmsov = 0
        this.seznamMobilnihPodatkovIzpis = []
        this.seznamSporocilIzpis = []
        this.seznamKlicevIzpis = []
        this.dodatnoZakupljeneEnotePrikaz = false
        if (typeof prenosniPodatki.units.information !== 'undefined') {
          for (let i = 0; i < prenosniPodatki.units.information.length; i++) {
            this.nazivStoritve = prenosniPodatki.units.information[i].description.split(' ', 2)
            this.nazivStoritve = this.nazivStoritve[0] + ' ' + this.nazivStoritve[1]
            this.vsebinaPaketa = prenosniPodatki.units.information[i]
            if (typeof this.vsebinaPaketa.rum !== 'undefined') {
              if (this.vsebinaPaketa.rum === 'DUR') {
                if (this.vsebinaPaketa.network === 'T2') {
                  this.seznamKlicevIzpis.push(this.vsebinaPaketa)
                }
              } else if (this.vsebinaPaketa.rum === 'VOL') {
                if (this.vsebinaPaketa.network === 'T2') {
                  this.seznamMobilnihPodatkovIzpis.push(this.vsebinaPaketa)
                }
              } else if (this.vsebinaPaketa.rum === 'EVT') {
                this.seznamSporocilIzpis.push(this.vsebinaPaketa)
                this.infoSporocilPaketa = this.vsebinaPaketa.limit
              }
            }
            this.vecInfoOpaketu = this.mobilniPaketMidi
            if (this.nazivStoritve === 'Dodatno zakupljene') {
              this.dodatnoZakupljeneEnotePrikaz = true
              this.dodatnoZakupljeneEnote = prenosniPodatki.units.information[i].limit - prenosniPodatki.units.information[i].free_units
              this.dodatnoZakupljeneEnoteLimit = prenosniPodatki.units.information[i].limit
              let objpodatkiZakupljeneEnote = {}
              objpodatkiZakupljeneEnote.description = 'Dodatno zakupljene enote.'
              objpodatkiZakupljeneEnote.used_unit = this.dodatnoZakupljeneEnote
              objpodatkiZakupljeneEnote.limit = this.dodatnoZakupljeneEnoteLimit
              this.seznamKlicevIzpis.push(objpodatkiZakupljeneEnote)
              this.seznamMobilnihPodatkovIzpis.push(objpodatkiZakupljeneEnote)
              this.seznamSporocilIzpis.push(objpodatkiZakupljeneEnote)
            }
          }
        }
      }
      if (typeof prenosniPodatki.exportData !== 'undefined' && prenosniPodatki.exportData !== null) {
        let izvozDnevnikKlicev = 'data:application/vnd.ms-excel;base64,' + prenosniPodatki.exportData
        const downloadLink = document.createElement('a')
        const fileName = 'Izvoz_Dnevnik_Klicev.xls'
        downloadLink.href = izvozDnevnikKlicev
        downloadLink.download = fileName
        downloadLink.click()
      }
      if (typeof prenosniPodatki.destinations !== 'undefined' && prenosniPodatki.destinations !== null) {
        let stevecZneskaSmsov = 0
        this.seznamRazdeljenihKlicev = []
        if (typeof prenosniPodatki.destinations.voice !== 'undefined') {
          for (let i = 0; i < prenosniPodatki.destinations.voice.length; i++) {
            if (typeof prenosniPodatki.destinations.voice[i].vat !== 'undefined') {
              this.davek = (100 + prenosniPodatki.destinations.voice[i].vat) / 100
              prenosniPodatki.destinations.voice[i].formatZnesek =
                (((prenosniPodatki.destinations.voice[i].amount * this.davek) /
                  100).toFixed(4).replace('.', ',') + ' €')
            }
            this.seznamRazdeljenihKlicev.push(prenosniPodatki.destinations.voice[i])
          }
        }
        if (typeof prenosniPodatki.details.message !== 'undefined' && prenosniPodatki.destinations.message !== null) {
          for (let i = 0; i < prenosniPodatki.details.message.length; i++) {
            this.seznamSmsov.push(prenosniPodatki.details.message[i])
            if (typeof prenosniPodatki.details.message[i].vat !== 'undefined') {
              this.davek = (100 + prenosniPodatki.details.message[i].vat) / 100
              prenosniPodatki.details.message[i].znesekSMSinMMSFormat =
                (((prenosniPodatki.details.message[i].amount * this.davek) /
                  100).toFixed(4).replace('.', ',') + ' €')
              stevecZneskaSmsov = stevecZneskaSmsov + prenosniPodatki.details.message[i].amount
              this.skupniZnesekSmsov = (((stevecZneskaSmsov * this.davek) /
                100).toFixed(2).replace('.', ',') + ' €')
            }
            let izpisFormatDatuma = this.PoenotenIzgledDatuma(prenosniPodatki.details.message[i].date)
            prenosniPodatki.details.message[i].formatDatumaSms = izpisFormatDatuma
          }
        }
        if (typeof this.seznamSmsov !== 'undefined' && this.seznamSmsov.length > 0) {
          let tmpArray = []
          this.dolzinaSeznamaSms = this.seznamSmsov.length
          let objDolzinaSeznamSms = {}
          objDolzinaSeznamSms.description = 'Poslanih SMS-ov in MMS-ov.'
          objDolzinaSeznamSms.used_unit = this.dolzinaSeznamaSms
          this.seznamSporocilIzpis.push(objDolzinaSeznamSms)
          const chunk = 4
          for (let i = 0; i < this.dolzinaSeznamaSms; i += chunk) {
            tmpArray.push(this.seznamSmsov.slice(i, i + chunk))
          }
          this.seznamSmsov = tmpArray
          this.PrikaziStranSms(1)
        }
        if (prenosniPodatki.destinations.message !== undefined && prenosniPodatki.destinations.message !== null) {
          for (let i = 0; i < prenosniPodatki.destinations.message.length; i++) {
            if (prenosniPodatki.destinations.message[i].billingCode === 'PUMMS-0') {
              this.steviloMmsov = prenosniPodatki.destinations.message[i].actualQuantity
            } else if (prenosniPodatki.destinations.message[i].billingCode === 'PUSMS-0') {
              this.steviloSmsov = prenosniPodatki.destinations.message[i].actualQuantity
            } else if (prenosniPodatki.destinations.message[i].billingCode === 'KDSMS') {
              if (prenosniPodatki.destinations.message[i].actualQuantity !== null) {
                let objSteviloDobrodelnihSmsov = {}
                objSteviloDobrodelnihSmsov.description = 'Poslanih dobrodelnih SMS-ov.'
                objSteviloDobrodelnihSmsov.used_unit = prenosniPodatki.destinations.message[i].actualQuantity
                this.seznamSporocilIzpis.push(objSteviloDobrodelnihSmsov)
              }
            }
            if (typeof prenosniPodatki.destinations.voice !== 'undefined') {
              prenosniPodatki.destinations.message[i].formatZnesekMessage =
                (((prenosniPodatki.destinations.message[i].amount * this.davek) /
                  100).toFixed(4).replace('.', ',') + ' €')
              this.seznamRazdeljenihSmsov.push(prenosniPodatki.destinations.message[i])
            }
          }
        }
        if (typeof prenosniPodatki.destinations.data !== 'undefined' && prenosniPodatki.destinations.data !== null) {
          for (let i = 0; i < prenosniPodatki.destinations.data.length; i++) {
            if (typeof prenosniPodatki.destinations.data !== 'undefined') {
              this.davek = (100 + prenosniPodatki.destinations.data[i].vat) / 100
              prenosniPodatki.destinations.data[i].formatZnesekData =
                (((prenosniPodatki.destinations.data[i].amount * this.davek) / 100).toFixed(4)
                  .replace('.', ',') + ' €')
            }
            prenosniPodatki.destinations.data[i].kolicinaPrenosa =
              this.PretvoriKolicinoVPrijaznoObliko(prenosniPodatki.destinations.data[i].actualQuantity)
            this.seznamPrenosaPodatkov.push(prenosniPodatki.destinations.data[i])
            if (prenosniPodatki.destinations.data[i].billingCode === 'PUDATAPRENOS-0,008197' ||
              prenosniPodatki.destinations.data[i].billingCode === 'PUDATAPRENOS-0') {
              let porabaObj = this.PretvoriKolicinoVPrijaznoObliko(prenosniPodatki.destinations.data[i].actualQuantity)
              this.prenosPodatkovT2 = porabaObj
            } else if (prenosniPodatki.destinations.data[i].billingCode === 'PUDATAPRETELEKOM-0') {
              let porabaObj = this.PretvoriKolicinoVPrijaznoObliko(prenosniPodatki.destinations.data[i].actualQuantity)
              this.prenosPodatkovTelekom = porabaObj
              let objpodatkiPrenosPodatkovTelekom = {}
              objpodatkiPrenosPodatkovTelekom.description = 'Prenos podatkov v omrežju A1.'
              objpodatkiPrenosPodatkovTelekom.used_unit = this.prenosPodatkovTelekom
            }
          }
        }
        let unitsInfo = prenosniPodatki.units
        if (unitsInfo !== 'undefined' && unitsInfo !== null) {
          if (typeof unitsInfo.dataBalance !== 'undefined' && unitsInfo.dataBalance !== null) {
            for (let i = 0; i < unitsInfo.dataBalance.length; i++) {
              if (unitsInfo.dataBalance[i].network.indexOf('IR') !== -1 || unitsInfo.dataBalance[i].network === 'NR') {
                this.seznamPrenosaPodatkov.push(unitsInfo.dataBalance[i])
                if (unitsInfo.dataBalance[i].network !== 'T2 | IR') {
                  let objpodatkiEuEea = {}
                  objpodatkiEuEea.description = unitsInfo.dataBalance[i].description
                  objpodatkiEuEea.used_unit = this.imePaketa !== 'Mobilni TOP'
                    ? unitsInfo.dataBalance[i].used_unit : (
                      (Number(unitsInfo.dataBalance[i].used_unit) / 100) * (1 + (StopnjaDDVEnum.DDV_PROCENTUALNO / 100))
                    )
                  objpodatkiEuEea.limit = unitsInfo.dataBalance[i].limit
                  objpodatkiEuEea.unit = unitsInfo.dataBalance[i].unit
                  objpodatkiEuEea.limit = unitsInfo.dataBalance[i].unit === 'EUR'
                    ? (
                      ((parseFloat(objpodatkiEuEea.limit)) / 100) * (1 + (StopnjaDDVEnum.DDV_PROCENTUALNO / 100))
                    ) : unitsInfo.dataBalance[i].limit
                  this.seznamMobilnihPodatkovIzpis.push(objpodatkiEuEea)
                }
              }
            }
          }
        }
        if (typeof prenosniPodatki.details !== 'undefined' && prenosniPodatki.details !== null &&
          typeof prenosniPodatki.details.voice !== 'undefined' &&
          prenosniPodatki.details.voice !== null && prenosniPodatki.details.voice.length > 0) {
          this.seznamKlicev = prenosniPodatki.details.voice
          let stevecSkupneSekunde = 0
          let stevecSkupnaVrednost = 0
          this.skupnaKolicinaSekund = 0
          this.skupnaKolicinaZnesek = 0
          for (let i = 0; i < this.seznamKlicev.length; i++) {
            if (this.seznamKlicev[i].callDirection > 0) {
              this.seznamKlicev[i].callDirection = 'Odhodni'
              this.seznamKlicevVT2Omrezje.length = 0
              this.seznamKlicevVTelemachOmrezje.length = 0
              this.seznamKlicevTujina.length = 0
              this.seznamKlicevSloOmrezje.length = 0
              for (let i = 0; i < prenosniPodatki.details.voice.length; i++) {
                let billingCode = prenosniPodatki.details.voice[i].billingCode
                if (this.seznamKlicev[i].callDirection === 'Odhodni') {
                  // klici v t2 omrezje
                  if (billingCode.substring(0, 11) === 'KXSLOF40630' ||
                    billingCode === 'KXSLOMT2-0' ||
                    billingCode.substring(0, 11) === 'KXSLOF40016') {
                    this.seznamKlicevVT2Omrezje.push(prenosniPodatki.details.voice[i])
                  } else if (billingCode.substring(0, 5) === 'KXSLO') {
                    this.seznamKlicevSloOmrezje.push(prenosniPodatki.details.voice[i])
                  } else {
                    this.seznamKlicevTujina.push(prenosniPodatki.details.voice[i])
                  }
                }
              }
              stevecSkupneSekunde = stevecSkupneSekunde + prenosniPodatki.details.voice[i].actualDuration
              this.skupnaKolicinaSekund = stevecSkupneSekunde
              if (typeof prenosniPodatki.details.voice[i].vat !== 'undefined') {
                this.davek = (100 + prenosniPodatki.details.voice[i].vat) / 100
                stevecSkupnaVrednost = stevecSkupnaVrednost + prenosniPodatki.details.voice[i].amount
                this.skupnaKolicinaZnesek = (((stevecSkupnaVrednost * this.davek) /
                  100).toFixed(4).replace('.', ',') + ' €')
              }
            } else {
              this.seznamKlicev[i].callDirection = 'Dohodni'
            }
          }
          this.skupnaKolicinaZnesekSI = this.PikeVVejice(this.skupnaKolicinaZnesek)
          this.SkupnoSteviloVsehKlicev = 0
          this.skupnoSteviloKlicevTujina = 0
          this.skupnoSteviloKlicevVSloveniji = 0
          this.skupnoSteviloKlicevVT2 = 0
          this.SkupnoSteviloVsehKlicev =
            parseInt(this.seznamKlicevVT2Omrezje.length +
              this.seznamKlicevVTelemachOmrezje.length +
              this.seznamKlicevTujina.length +
              this.seznamKlicevSloOmrezje.length)
          this.skupnoSteviloKlicevTujina = this.seznamKlicevTujina.length
          this.skupnoSteviloKlicevVSloveniji = this.seznamKlicevSloOmrezje.length + this.seznamKlicevVT2Omrezje.length
          let obj = {}
          obj.description = 'Klici v slovenska omrežja.'
          obj.used_unit = this.skupnoSteviloKlicevVSloveniji
          this.seznamKlicevIzpis.push(obj)
          this.skupnoSteviloKlicevVT2 = this.seznamKlicevVT2Omrezje.length
          let objKliciT2 = {}
          objKliciT2.description = 'Število klicev v T-2 omrežje.'
          objKliciT2.used_unit = this.skupnoSteviloKlicevVT2
          this.seznamKlicevIzpis.push(objKliciT2)
        } else {
          this.seznamSmsov = []
          this.dolzinaSeznamaSms = 0
          this.PrikaziStranSms(1)
        }
      }
      this.nalaganjeStatistikeKlicev = false
      if (typeof this.telefonskeStevilkeStrankeAsoc[this.izbranSap] !== 'undefined' &&
        typeof this.telefonskeStevilkeStrankeAsoc[this.izbranSap][this.telefonskaStevilka] !== 'undefined') {
        let nazivStoritve = this.telefonskeStevilkeStrankeAsoc[this.izbranSap][this.telefonskaStevilka].storitevNaziv
        if (typeof nazivStoritve === 'undefined') {
          nazivStoritve = this.telefonskeStevilkeStrankeAsoc[this.izbranSap][this.telefonskaStevilka].trzni_paket
        }
      }
    },
    PrikaziStranSms (stran) {
      this.trenutnoIzbranaStranSms = stran
      if (typeof this.seznamSmsov[this.trenutnoIzbranaStranSms - 1] !== 'undefined') {
        this.podseznamPodatkovSmsov = this.seznamSmsov[this.trenutnoIzbranaStranSms - 1]
      } else {
        this.podseznamPodatkovSmsov = []
      }
    }
  },
  watch: {
    stevecPoizvedb: {
      immediate: true,
      handler (val, oldVal) {
        if (this.izbranSap !== '') {
          this.GetPorabaInfo()
          this.ResetPodatkov()
        }
      }
    },
    izbranSap (sapValue) {
      if (sapValue !== null && sapValue !== '') {
        this.stevecPoizvedb++
      }
    }
  }
}
</script>
<style scoped src="../../../../../../static/css/Poraba/PorabaTelefonija/Povzetek.css">
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Poraba/PorabaTelefonija/Povzetek.vue